module.exports = __webpack_public_path__ + "static/media/FAMILIASOLAR-01.835f43d0.png";